(ns frontend.view.nev.kyc.process.smo-editor
  (:require
   [clojure.data :as data]
   [common.country :as country]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]
   [frontend.state.current-session :as session]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.kyc.process-status-views.view-utils :as view-utils]
   [common.schema.entities.workspace.kyc.questions.smo :as smo-schema]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [common.util :as cu]))

(defn open-smo-editor
  [{:keys [idx existing-smo kyc-entity-editor process-id state-atom lang-kw question-attribute
           question-meta answers-atom mandatory? read-only? save!]}]
  (let [kyc-process (session/get-entity process-id)
        smo-answers (r/atom (or existing-smo {}))
        smos (get @answers-atom question-attribute)
        field-errors-atom (r/atom {})
        smo-template-schema (:data/template question-meta)
        calc-new-smo-answer (fn []
                              (if (>= idx (count smos))
                                (concat smos
                                        [(assoc @smo-answers
                                                :ord
                                                (count smos))])
                                (->> smos
                                     (map-indexed (fn [uidx smo]
                                                    (assoc (if (= uidx idx)
                                                             @smo-answers
                                                             smo)
                                                           :ord
                                                           uidx)))
                                     (vec))))]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :add-smo nil lang-kw)
      :render-fn           (fn [_state]
                             [:div
                              [kyc-entity-editor
                               {:container-id    (str "SMO-" idx)
                                :process-id      process-id
                                :state-atom      state-atom
                                :save!           identity
                                :mandatory?      mandatory?
                                :skip-info?      true
                                :read-only?      read-only?
                                :answers-atom    smo-answers
                                :template-schema smo-template-schema
                                :field-errors-atom field-errors-atom
                                :lang-kw         lang-kw}]])
      :show-button?        (not read-only?)
      :button-text         (loc/tr :save nil lang-kw)
      :custom-validator-fn (fn [_state]
                             (let [[old-only new-only _] (data/diff existing-smo @smo-answers)
                                   changes? (or (seq old-only)
                                                (seq new-only))]
                               (view-utils/modal-validator-tooltip
                                {:lang-kw           lang-kw
                                 :template-schema   smo-template-schema
                                 :answers-atom      smo-answers
                                 :field-errors-atom field-errors-atom
                                 :kyc-process       kyc-process
                                 :changes?          changes?})))
      :on-submit!          (fn [_]
                             (let [new-value (calc-new-smo-answer)]
                               (swap! answers-atom assoc question-attribute new-value)
                               (save!)))
      :on-before-close!    (fn [close!]
                             (if (= (get @answers-atom question-attribute) (calc-new-smo-answer))
                               (close!)
                               (modals/open-modal!
                                confirmation-modal/modal-key
                                {:body           (loc/tr :confirm-close-kyc-modal-without-saving nil lang-kw)
                                 :confirm-text   (loc/tr :close-without-saving nil lang-kw)
                                 :confirm-icon   ""
                                 :skip-checkbox? true
                                 :on-confirm     #(close!)})))})))

(defn translate-management-position
  [position lang-kw]
  (let [translations (->> smo-schema/management-position-options
                          (cu/find-one :key position)
                          :translations)
        position-text (get-in translations [position lang-kw])]
    position-text))

(defn view
  [{:keys [process-id lang-kw question-attribute question-meta
           answers-atom mandatory? read-only? save!]
    :as   args}]
  (let [smos (get @answers-atom question-attribute)
        process (session/get-entity process-id)
        smo-schema (:data/template question-meta)
        wip-status? (-> process
                        :kyc-process/status
                        (= :kyc-process.status/wip))
        sorted-smos (sort-by :ord smos)
        smo-missing-data-indices
        (->> sorted-smos
             (map-indexed
              (fn [idx smo]
                (let [missing-fields (view-utils/resolve-missing-fields lang-kw
                                                                        smo-schema
                                                                        (atom smo)
                                                                        process)]
                  [idx missing-fields])))
             (filterv (fn [[_idx missing-fields]]
                        (seq missing-fields)))
             (mapv first)
             set)]
    [:div
     [:div.input-editor__label
      [:label.input-editor__label-text.pb-2
       {:class
        (when mandatory?
          "after:ml-0.5 after:text-danger-regular after:content-['*']")}
       (-> question-meta
           :translations
           (get lang-kw))]]
     (if (and read-only?
              (empty? smos))
       [:div.preview
        [:span (loc/tr :no-smos)]]
       [:div.max-w-100.hide-scrollbar
        [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
         [:thead.zap-table__headline
          [:tr.zap-table__row
           [:th.zap-table__headline ""]
           [:th.zap-table__headline
            (kyc-utils/localize-question smo-schema :kyc-smo/first-name lang-kw)]
           [:th.zap-table__headline
            (kyc-utils/localize-question smo-schema :kyc-smo/last-name lang-kw)]
           [:th.zap-table__headline
            (kyc-utils/localize-question smo-schema :kyc-smo/management-position lang-kw)]
           [:th.zap-table__headline
            (kyc-utils/localize-question smo-schema :kyc-smo/country lang-kw)]
           [:th.zap-table__headline (kyc-utils/localize-question smo-schema :kyc-smo/pep lang-kw)]
           [:th.zap-table__headline ""]]]
         [:tbody
          (->>
           sorted-smos
           (map-indexed
            (fn [idx smo]
              [:tr
               {:key (str "SMO-" idx "-" (:ord smo))}
               [:td.zap-table__cell
                [:i.fal.fa-external-link.clickable
                 {:on-click (fn [_]
                              (open-smo-editor (assoc args
                                                      :idx idx
                                                      :existing-smo smo)))}]]
               [:td.zap-table__cell
                (:kyc-smo/first-name smo)]
               [:td.zap-table__cell
                (:kyc-smo/last-name smo)]
               [:td.zap-table__cell
                (let [position (:kyc-smo/management-position smo)]
                  (if (= position :management-position/other)
                    (:kyc-smo/management-position-other smo)
                    (translate-management-position position lang-kw)))]
               [:td.zap-table__cell
                (country/get-label (:kyc-smo/country smo) lang-kw)]
               [:td.zap-table__cell
                (when-let [is-pep-kw (:kyc-smo/pep smo)]
                  (kyc-utils/localize-display-string smo-schema :kyc-smo/pep is-pep-kw lang-kw))]
               [:td.zap-table__cell
                (when (and wip-status?
                           (seq smo-missing-data-indices))
                  {:style {:border-right "1px solid #D9D9DA"}})
                (when-not read-only?
                  [:i.fal.fa-trash-alt.pointer
                   {:on-click (fn [_]
                                (swap! answers-atom assoc
                                       question-attribute
                                       (concat (take idx smos)
                                               (drop (inc idx) smos)))
                                (save!))}])]

               (when (and wip-status?
                          (contains? smo-missing-data-indices idx))
                 [:td
                  {:class "px-3 py-2"}
                  [tooltip/view
                   [:i {:class "fal fa-exclamation-triangle text-danger-regular"}]
                   [:span (loc/tr :data-missing nil lang-kw)]]])]))
           (doall))]
         (when-not read-only?
           [:tfoot
            [:tr.zap-table__row
             [:td.zap-table__footer-cell {:col-span "2"}
              [button/primary-solid
               {:on-click (fn [_]
                            (let [idx (count smos)]
                              (open-smo-editor (assoc args :idx idx))))}
               [:i.fal.fa-plus.pr-2]
               (loc/tr :add-new nil lang-kw)]]]])]])]))
